import styled from "styled-components";

export const ItemListContent = styled.div`
    width: 100%;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    background: ${props => props.zebra ? 'white' : '#F9F9F9'}
    border-bottom: 1px solid #E2E2E2;
    svg {
        color: ${props => props.type === 'Acumulo' ? '#119C4A' : '#DD1F1F'};
        font-size: 30px;
        margin-right: 18px;
    }
`;

export const ItemListInfo = styled.div`
    display: flex;
    align-items: center;
`;

export const ItemListDate = styled.div`
    font-size: 14px;
`;

export const ItemListText = styled.div`
    display: flex;
    flex-direction: column;
    line-height: 1.25;
    span{
        font-size: 12px;
    }
`;

export const ItemListPoints = styled.div`
    color: ${props => props.type === 'Acumulo' ? '#119C4A' : '#DD1F1F'};
    font-size: 16px;
    font-weight: 500;
`;




